export function _quickEditAdArray(_t){



  var url3 = dzsvg_settings.ad_builder_url;


  window.ad_target_field = _t.prev();
  if (_t.parent().parent().hasClass('zoomsounds-inspector-setting')) {
    window.ad_target_field = _t.parent().parent().find('input').eq(0);
  }
  if (window.ad_target_field.val()) {
    url3 += '&adstart=' + encodeURIComponent(window.ad_target_field.val());
  }


  window.open_ultibox(null, {
    type: 'iframe'
    , source: url3
    , scaling: 'fill' // -- this is the under description
    , suggested_width: '800' // -- this is the under description
    , suggested_height: '700' // -- this is the under description
    , item: null // -- we can pass the items from here too

  });


}
export function _quickEditQualityArray(_t){


  if (_t.hasClass('quick-edit-qualityarray')) {
    var url3 = dzsvg_settings.quality_builder_url;


    window.quality_target_field = _t.prev();
    if (_t.prev().val()) {
      url3 += '&qualitystart=' + encodeURIComponent(_t.prev().val());
    }

    window.open_ultibox(null, {


      type: 'iframe'
      , source: url3
      , scaling: 'fill' // -- this is the under description
      , suggested_width: '800' // -- this is the under description
      , suggested_height: '700' // -- this is the under description
      , item: null // -- we can pass the items from here too

    });


    return false;
  }


}
